import { locales } from '@americanexpress/conditional-features';

export const DUAL_LANGUAGE_MARKETS = {
  ca: [locales.EN_CA, locales.FR_CA],
  hk: [locales.EN_HK, locales.ZH_HK],
  us: [locales.EN_US, 'es-US'],
};
